import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

class Caption extends React.PureComponent {
    static propTypes = {
        docData: PropTypes.object,
        changeView: PropTypes.string,
    };

    handleRevisit = () => {
        window.location.href = window.location.href.split('#')[0];
    };
    /**
     * 渲染网页布局
     */
    render() {
        const { docData, changeView } = this.props;
        const { newsTime, title, source, sourceUrl, fhhAccountDetail, subscribe } = docData;

        console.log(subscribe, '3222');

        return changeView !== 'isOver' ? (
            <div className={styles.titL}>
                <h1>{title}</h1>
                <p>
                    <span>{newsTime.slice(0, newsTime.length - 3)}</span>
                    {fhhAccountDetail.weMediaName ? (
                        <a
                            href={`//ishare.ifeng.com/mediaShare/home/${fhhAccountDetail.eAccountId}/media`}
                            target="_blank"
                            className={styles.source}>
                            {fhhAccountDetail.weMediaName}
                        </a>
                    ) : (
                        <span>
                            {sourceUrl ? (
                                <a href={sourceUrl} target="_blank" className={styles.source}>
                                    {source}
                                </a>
                            ) : (
                                <span>{source}</span>
                            )}
                        </span>
                    )}
                    <span>{subscribe?.lastArticleAddress || ''}</span>
                </p>
            </div>
        ) : (
            <div className={styles.overReTit}>
                <a className={styles.picAgain} onClick={this.handleRevisit}>
                    图集浏览结束，重新浏览
                    <span className={styles.againBtn} />
                </a>
            </div>
        );
    }
}

export default errorBoundary(Caption);
